import React, {useEffect, Fragment} from 'react';
import '../../sass/home.scss';
import {Container, Row, Col, Button} from 'reactstrap';
import {connect} from 'react-redux';
import {fetchArticles} from '../../reducer/article-reducer';
import {Link} from 'react-router-dom';

type article = {
  title: string;
  pictureUrl: string;
  id: string;
};
interface configObject {
  user: {
    token: string;
  };
  articles: {
    articles: [article];
  };
}

interface propiedades {
  fetchArticles(token: string): any;
  token: string;
  articles: [article];
}

const Home = (props: propiedades) => {
  const {fetchArticles, token, articles} = props;

  useEffect(() => {
    if (token !== '' && articles === null) {
      fetchArticles(token);
    }
  }, [fetchArticles, token, articles]);

  return (
    <div
      className="home justify-content-around d-flex flex-column"
      style={{backgroundImage: 'url(/img/admin_home.jpg)'}}
    >
      <Container>
        <Row>
          <Col className="mt-4 text-center">
            <h1 className="text-center base-primary mt-4 mb-3">
              Te damos la bienvenida a tu gestor de contenidos
            </h1>
            <Button
              tag={Link}
              className="background-primary text-color border-primary mt-4"
              to={'/admin/nuevo-articulo'}
            >
              Crear nuevo contenido
            </Button>
          </Col>
        </Row>
      </Container>
      <div className="background-secondary home-articles">
        {!articles && (
          <div className="loading-wrapper">
            <div className="lds-dual-ring"></div>
          </div>
        )}
        {articles && (
          <Container>
            <Row>
              <Col>
                <h2 className="h4 color-primary pt-1 pb-1">
                  últimos artículos publicados{' '}
                </h2>
              </Col>
            </Row>
            <Row>
              {articles?.map((article, index) => {
                return (
                  <Fragment key={index}>
                    {index < 3 ? (
                      <Col
                        key={index}
                        md={4}
                        className="position-relative article-wrapper"
                      >
                        <div className="inner-article">
                          {article.pictureUrl ? (
                            <img
                              src={article.pictureUrl}
                              alt=""
                              className="img-fluid"
                            />
                          ) : (
                            <img
                              src="https://lunawood.com/wp-content/uploads/2018/02/placeholder-image.png"
                              className="img-fluid"
                              alt=""
                            />
                          )}
                          <div className="position-absolute bottom-0 w-100 p-2">
                            <div className="back-title background-base w-100 position-absolute bottom-0 h-100 start-0"></div>
                            <Link
                              className="color-text text-decoration-none h4 position-relative"
                              to={`/admin/articulo/${article.id}`}
                            >
                              {article.title}
                            </Link>
                          </div>
                        </div>
                      </Col>
                    ) : null}
                  </Fragment>
                );
              })}
            </Row>
          </Container>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    articles: state.articles.articles,
  };
};
export default connect(mapStateToProps, {fetchArticles})(Home);
